export const baseNavigationTestId = 'base-navigation-test-id';
export const helpButtonTestId = 'help-test-id';
export const pricingExcellenceButtonTestId = 'pricing-excellence-test-id';
export const logoutTestid = 'logout-test-id';
export const logoutprofileTestid = 'logoutprofile-test-id';
export const dealNameTestid = 'deal-name-test-id';
export const customerNameTestid = 'customer-name-test-id';
export const productStartDateTestId = 'product-start-date-test-id';
export const productEndDateTestId = 'product-end-date-test-id';
export const contractEndTestid = 'contract-end-test-id';
export const dealDescription = 'deal-description-test-id';
export const regionProductHeader = 'region-product-header-test-id';
export const productTestId = 'product-test-id';
export const creditTestId = 'credit-test-id';
export const selectRegionTestid = 'select-region-test-id';
export const selectProductLineTestid = 'select-product-line-test-id';
export const creditStandardEndOfMonthTestId = 'credit-standard-end-of-month-test-id';
export const creditStandardInvoiceTestId = 'credit-standard-invoice-test-id';
export const creditProposedEndOfMonthTestId = 'credit-proposed-end-of-month-test-id';
export const creditProposedInvoiceTestId = 'credit-proposed-invoice-test-id';
export const nonRiskModaltestid = 'non-risk-modal-test-id';
